import { Component } from 'js-component-framework';

/**
 * Component for instantiating LearnMore.
 */
export default class LearnMore extends Component {

  /**
   * Start the component.
   */
  constructor(config) {
    super(config);

    // Elements
    this.learnMoreBox = document.getElementById(this.options.boxId);
    this.close = this.learnMoreBox.querySelector('.landing-learn-more__close');

    // Init
    if (this.learnMoreBox && this.close) {
      this.setShowTrigger();
      this.setHideTrigger();
    }
  }

  /**
   * Set trigger to show learn more box
   */
  setShowTrigger() {
    this.element.addEventListener('click', () => {
      this.show();
    });
  }

  /**
   * Set trigger to hide learn more box
   */
  setHideTrigger() {
    this.close.addEventListener('click', () => {
      this.hide();
    });
  }

  /**
   * Show learn more box
   */
  show() {
    this.learnMoreBox.classList.remove(this.options.boxClosedClass);
    this.learnMoreBox.classList.add(this.options.boxActiveClass);
  }

  /**
   * Hide learn more box
   */
  hide() {
    this.learnMoreBox.classList.remove(this.options.boxActiveClass);
    this.learnMoreBox.classList.add(this.options.boxClosedClass);
  }
}



// WEBPACK FOOTER //
// ./client/js/components/LearnMore/LearnMore.js